module.exports = __webpack_public_path__ + "img/cancel_button.0192b005.svg";